<template>
  <b-list-group class="w-100">
    <h6 :class="isFilter ? 'text-danger' : 'text-primary'">
      {{ $t(title) }}
    </h6>
    <template v-for="(field, j) in fields">
      <b-list-group-item
        class="w-100"
        v-if="typeof field.type === 'string' && field.type.length > 1"
        :id="isFilter ? `F_${field.key}` : field.key"
      >
        <div class="d-flex w-100">
          <b-form-checkbox
            @change="tableChecked($event, j, field)"
            ref="tableCheckbox"
            :class="
              isFilter ? 'custom-control-danger' : 'custom-control-primary'
            "
          ></b-form-checkbox>
          <fields-list
            :key="expanded"
            :title="field.key"
            :fields="field.values"
            :filters="innerFilters"
            :objKey="field.key"
            :dataPath="`${dataPath}.${field.key}`"
            :isFilter="isFilter"
            @fieldChecked="$emit('fieldChecked')"
          />
        </div>
      </b-list-group-item>
      <template v-else>
        <b-list-group-item
          v-if="field.key !== 'inputs'"
          class="d-flex"
          :key="j"
          :id="isFilter ? `F_${field.key}` : field.key"
        >
          <b-form-checkbox
            @change="fieldChecked($event, field.key)"
            ref="fieldCheckbox"
            :class="
              isFilter ? 'custom-control-danger' : 'custom-control-primary'
            "
          >
            {{ $t(field.key) }}
          </b-form-checkbox>
        </b-list-group-item>
      </template>
    </template>
  </b-list-group>
</template>

<script>
import { BFormCheckbox, BListGroup, BListGroupItem } from "bootstrap-vue";
import { mapMutations, mapGetters } from "vuex";
import * as models from "@/schema/schema.js";

import get from "lodash.get";
export default {
  name: "FieldsList",
  props: {
    title: String,
    fields: Array,
    filters: Object,
    objKey: String,
    dataPath: String,
    isFilter: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {
    BFormCheckbox,
    BListGroup,
    BListGroupItem,
  },
  data() {
    return {
      expanded: 0,
      innerFilters: {},
    };
  },
  computed: {
    ...mapGetters("AdvancedReports", ["savedFields", "savedFilters"]),
  },

  methods: {
    get,
    ...mapMutations("AdvancedReports", [
      "setQuery",
      "unsetQuery",
      "setFilter",
      "unsetFilter",
      "pushField",
      "removeField",
    ]),
    tableChecked(e, index, field) {
      if (e) {
        var temp = new models[field.type]().inputs;
        this.fields[index].values = new models[field.type]().getProps(true);
        this.innerFilters = temp;
        this.expanded++;
      } else {
        this.fields[index].values;
        delete this.fields[index].values;
        this.unsetQuery({ path: this.dataPath, key: field.key });
        this.expanded++;
      }
    },
    fieldChecked(e, key) {
      const fieldKey = key === "id" ? "ids" : key;
      this.$emit("fieldChecked");
      if (e) {
        const label =
          this.$t(key) +
          " " +
          this.dataPath
            .split(".")
            .slice(1)
            .map((el) => `(${this.$t(el)})`)
            .join(" ");
        if (this.isFilter)
          this.setFilter({
            path: `${this.dataPath}.${fieldKey}`,
            value: {
              ...this.filters[key],
              key: `${this.dataPath}.${fieldKey}`,
            },
            label: label,
          });
        else {
          this.setQuery({ path: `${this.dataPath}.${key}`, value: true });
          var arr = this.dataPath.split(".").slice(1);
          arr.push(key);
          this.pushField(arr.join("."));
        }
      } else {
        if (this.isFilter)
          this.unsetFilter({ path: this.dataPath, key: fieldKey });
        else {
          var arr = this.dataPath.split(".").slice(1);
          arr.push(key);
          this.removeField(arr.join("."));
          this.unsetQuery({ path: this.dataPath, key: key });
        }
      }
    },
  },
};
</script>
